import { render, staticRenderFns } from "./handCardDialog.vue?vue&type=template&id=47c690d3&scoped=true"
import script from "./handCardDialog.vue?vue&type=script&lang=js"
export * from "./handCardDialog.vue?vue&type=script&lang=js"
import style0 from "./handCardDialog.vue?vue&type=style&index=0&id=47c690d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c690d3",
  null
  
)

export default component.exports